import DashboardHeroSection from "components/dashboard/DashboardHeroSection";
import UserDetails from "components/dashboard/UserDetails";
import Footer from "components/footer/Footer";
import Header from "components/header/Header";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "redux-store/store";
import UserAuth from "components/AuthGaurd/UserAuth";
import { getnotReceiveTests, getnotsubmittedTests } from "redux-store/lab-tests/tests.slice";

const Dashboard = () => {
  // const tests = useSelector(test);
  const [tests, setTests] = useState([]);
  const dispatch = useDispatch<AppDispatch>();
  // let count = 0;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    dispatch(getnotReceiveTests()).then((res) => {
      const data = res.payload.labResults;
      setTests(data);
      setLoading(false);
    });
  }, []);

  return (
    <UserAuth>
      <header>
        <Header admin={true} />
      </header>

      {/* Hero Section */}
      <DashboardHeroSection title="Dashboard">
        {loading ? (
          <div className="tw-flex tw-justify-center tw-items-center tw-h-screen">Loading...</div>
        ) : tests && tests.length !== 0 ? (
          <UserDetails setTests={setTests} setLoadings={setLoading} kits={tests} />
        ) : (
          <span className="tw-text-2xl tw-text-gray-800 tw-text-center tw-font-semibold">No Active Kits Found</span>
        )}
      </DashboardHeroSection>

      <footer className="tw-flex">
        <Footer />
      </footer>
    </UserAuth>
  );
};

export default Dashboard;
